var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSovcombank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SovCom",
    clipPath: "url(#clip0_342:15901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0.200073V5.40007H10C8.80002 5.40007 7.60002 5.90007 6.75002 6.75007C5.90002 7.60007 5.40002 8.80007 5.40002 10.0001C5.40002 11.2001 5.90002 12.4001 6.75002 13.2501C7.60002 14.1001 8.80002 14.6001 10 14.6001H12V19.8001C14.25 19.3501 16.3 18.1501 17.75 16.3501C19.2 14.5001 20 12.3001 20 10.0001C20 7.70007 19.2 5.45007 17.75 3.70007C16.3 1.90007 14.25 0.650073 12 0.200073Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 16.2C8.4 16.15 6.85 15.5 5.7 14.3C4.55 13.15 3.95 11.6 3.95 9.95C3.95 8.3 4.6 6.8 5.7 5.6C6.85 4.5 8.4 3.8 10 3.75H10.4V0H10C7.35 0 4.8 1.05 2.95 2.95C1.05 4.8 0 7.35 0 10C0 12.65 1.05 15.2 2.95 17.05C4.8 18.95 7.35 20 10 20H10.4V16.2H10Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342:15901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovcombank);
export default __webpack_public_path__ + "static/media/sovcombank.fd6486d2485960ed779808a213fd2408.svg";
export { ForwardRef as ReactComponent };